import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { constants } from "@qgiv/core-js";
import {
    selectRegistrationsFromRegistration,
    selectUnconfirmedRegistrations,
} from "../../../redux/slices/registrationSlice";
import { selectBaseUrl } from "../../../redux/slices/p2pSettingsSlice";
import ErrorRedirect from "./ErrorRedirect";

const ConnectedErrorRedirect = ({ localErroredEntities = [] }) => {
    const {
        ENUMS: {
            EntityType: { TEAM },
        },
    } = constants;
    const { totalUnconfirmedRegistrations } = useSelector(
        selectUnconfirmedRegistrations,
    );
    const registrations = useSelector(selectRegistrationsFromRegistration);
    const baseUrl = useSelector(selectBaseUrl);

    const primaryRegistrant = registrations[0];
    const shouldHideForm =
        Object.keys(primaryRegistrant).length > 0 &&
        primaryRegistrant?.Registration_Role[0] === `${TEAM}` &&
        primaryRegistrant?.Team === "";

    const errorRedirectProps = {
        baseUrl,
        localErroredEntities,
        totalUnconfirmedRegistrations,
        shouldHideForm,
    };

    return <ErrorRedirect {...errorRedirectProps} />;
};

ConnectedErrorRedirect.propTypes = {
    localErroredEntities: PropTypes.arrayOf(PropTypes.shape({})),
};

export default ConnectedErrorRedirect;
